import React from 'react';
import { format, parseISO } from 'date-fns';

const DISCIPLINE_COLORS = {
  sea_kayaking: { bg: 'var(--sea-bg)', color: 'var(--sea)' },
  whitewater: { bg: 'var(--ww-bg)', color: 'var(--ww)' },
  canoe: { bg: 'var(--canoe-bg)', color: 'var(--canoe)' },
  surfski: { bg: 'var(--surfski-bg)', color: 'var(--surfski)' },
  sup: { bg: 'var(--sup-bg)', color: 'var(--sup)' },
  other: { bg: 'var(--other-bg)', color: 'var(--other)' },
};

function fmt(dateStr) {
  if (!dateStr) return '—';
  try { return format(parseISO(dateStr), 'MMMM d, yyyy'); }
  catch { return dateStr; }
}

export default function EventDetail({ opp, onClose, likedIds, onToggleLike }) {
  if (!opp) return null;
  const disc = DISCIPLINE_COLORS[opp.opportunity_class] || DISCIPLINE_COLORS.other;
  const isSameDay = opp.event_start_date === opp.event_end_date;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="event-modal" onClick={e => e.stopPropagation()}>
        <div className="event-modal-header" style={{ borderTop: `4px solid ${disc.color}` }}>
          <div className="event-modal-top">
            <div className="event-badges">
              <span className="event-badge" style={{ background: disc.bg, color: disc.color }}>
                {opp.opportunity_class?.replace('_', ' ') || 'Other'}
              </span>
              <span className="event-badge-outline">{opp.opportunity_type || 'unknown'}</span>
            </div>
            <div style={{display:'flex', gap:'8px', alignItems:'center'}}>
              <button
                className={`heart-btn heart-btn-lg ${likedIds?.has(Number(opp.capture_id)) ? 'heart-liked' : ''}`}
                onClick={() => onToggleLike(opp.capture_id)}
                title={likedIds?.has(Number(opp.capture_id)) ? 'Unlike this event' : 'Like this event'}
              >
                {likedIds?.has(Number(opp.capture_id)) ? '❤️' : '🤍'}
              </button>
              <button className="close-btn-light" onClick={onClose}>✕</button>
            </div>
          </div>
          <h2 className="event-modal-title">{opp.opportunity_name || '—'}</h2>
          <div className="event-modal-outfit">{opp.outfit_name || '—'}</div>
        </div>

        <div className="event-modal-divider" />
        <div className="event-modal-body">
          {opp.image_url && (
            <div className="event-image-wrap">
              <img
                src={opp.image_url}
                alt={opp.opportunity_name || 'Event'}
                className="event-image"
                onError={e => { e.target.style.display = 'none'; e.target.parentNode.style.display = 'none'; }}
              />
            </div>
          )}
          <div className="detail-grid">
            <div className="detail-item">
              <div className="detail-label">Dates</div>
              <div className="detail-value">
                {fmt(opp.event_start_date)}
                {!isSameDay && opp.event_end_date && (
                  <> → {fmt(opp.event_end_date)}</>
                )}
              </div>
            </div>

            {opp.cost_text && (
              <div className="detail-item">
                <div className="detail-label">Cost</div>
                <div className="detail-value">{opp.cost_text}</div>
              </div>
            )}

            {opp.phone_number && (
              <div className="detail-item">
                <div className="detail-label">Phone</div>
                <div className="detail-value">
                  <a href={`tel:${opp.phone_number}`}>{opp.phone_number}</a>
                </div>
              </div>
            )}
          </div>

          {(opp.address_raw || opp.address_street || opp.address_city) && (
            <div className="detail-section">
              <div className="detail-label">Location</div>
              {opp.address_street && <div className="detail-value">{opp.address_street}</div>}
              <div className="detail-value">
                {[opp.address_city, opp.address_state, opp.address_zip].filter(Boolean).join(', ')}
                {opp.address_country && ` · ${opp.address_country}`}
              </div>
              {opp.address_raw && opp.address_raw !== opp.address_street && (
                <div className="detail-raw">{opp.address_raw}</div>
              )}
            </div>
          )}

          {opp.opportunity_summary && (
            <div className="detail-section">
              <div className="detail-label">About</div>
              <div className="detail-summary">{opp.opportunity_summary}</div>
            </div>
          )}

          {opp.website_url && (
            <div className="detail-section">
              <a
                href={opp.website_url}
                target="_blank"
                rel="noreferrer"
                className="btn-visit"
              >
                Visit Website →
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
